import React, { useState } from 'react';
import withholdingPeriods from '../witholding_periods.json';
import { HeaderTitle, ModalButton, ModalWrapper } from '../Cvd.style';
import {
  ModalGap,
  // StyledOption,
  StyledSelect,
  StyledSelectLabel,
  StyledSelectWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { InputField } from '../../../../Components/uielements';
import moment from 'moment';
import ChildModal from '../../../../Components/uielements/modal/childModal';

const AddProductModal = ({
  addProductModal,
  toggleAddProductModal,
  setCvdFormData,
  cvdFormData,
}) => {
  const productList = withholdingPeriods;

  const [WHP, setWHP] = useState('');

  const handleAddProductSubmit = (e) => {
    e.preventDefault();
    setCvdFormData({
      ...cvdFormData,
      chemicals: [
        ...cvdFormData.chemicals,
        {
          chemicalName: e.target['productName'].value,
          rate: e.target['rate'].value,
          applicationDate: e.target['applicationDate'].value,
          WHP: e.target['whp'].value,
        },
      ],
    });
    toggleAddProductModal();
  };

  const handleProductChange = (e) => {
    var productData = productList.find(
      (data) => data['APVMA registered product name'] === e.target.value
    );
    setWHP(productData['WHP (days)']);
  };

  return (
    <ChildModal isOpen={addProductModal} onClose={toggleAddProductModal}>
      <ModalWrapper>
        <form onSubmit={handleAddProductSubmit}>
          <ModalGap>
            <HeaderTitle>Add Product</HeaderTitle>
            {/* <FormControl style={{ marginLeft: 8 }} fullWidth>
            <InputLabel id="demo-simple-select-label">Product Name</InputLabel>
            <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Product Name" name="productName" onChange={handleProductChange}>
              {productList.map((data) => (
                <MenuItem value={data['APVMA registered product name']}>{data['APVMA registered product name']}</MenuItem>
              ))}
            </Select>
          </FormControl> */}
            <StyledSelectWrapper>
              <StyledSelectLabel>Product Name</StyledSelectLabel>
              <StyledSelect
                name="productName"
                defaultValue={cvdFormData['unit1']}
                onChange={handleProductChange}
              >
                {productList?.map((option, i) => (
                  <option key={i} value={option['APVMA registered product name']}>
                    {option['APVMA registered product name']}
                  </option>
                ))}
              </StyledSelect>
            </StyledSelectWrapper>
            <InputField id="outlined-required" Name="Rate" name="rate" fullWidth />
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateField
              sx={{ margin: 1, color: 'black' }}
              id="outlined-required"
              label="Application Date"
              format="DD-MM-YYYY"
              defaultValue={dayjs(new Date())}
              name="applicationDate"
              fullWidth
            />
          </LocalizationProvider> */}
            <InputField
              type="date"
              Name="Application Date"
              format="DD-MM-YYYY"
              defaultValue={moment().format('DD-MM-YYYY')}
              name="applicationDate"
              fullWidth
            />

            <InputField Name="WHP / ESI / EAFI" defaultValue={WHP} name="whp" fullWidth />

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <ModalButton type="submit" variant="contained">
                Submit
              </ModalButton>
              <ModalButton onClick={() => toggleAddProductModal()} variant="outlined">
                Cancel
              </ModalButton>
            </div>
          </ModalGap>
        </form>
      </ModalWrapper>
    </ChildModal>
  );
};

export default AddProductModal;
